import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const CustomerFilterPage = lazy(() => import("@/pages/customer-filter/page"));
const CustomerProfilePage = lazy(() => import("@/pages/customer-profile/page"));
const StrategyReportPage = lazy(() => import("@/pages/strategy-report/page"));
const StrategyReportDetailPage = lazy(() => import("@/pages/strategy-report-detail/page"));
const StrategyReportWealthDetailPage = lazy(() => import("@/pages/strategy-report-wealth-detail/page"));
const BestCasesPage = lazy(() => import("@/pages/best-cases/page"));
const AIChatPage = lazy(() => import("@/pages/ai-chat/page"));
const ProfilePage = lazy(() => import("@/pages/profile/page"));
const DashboardPage = lazy(() => import("@/pages/dashboard/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));
import StrategyHistory from '../pages/strategy-history/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/customer-filter" replace />,
  },
  {
    path: "/customer-filter",
    element: <CustomerFilterPage />,
  },
  {
    path: "/customer-profile",
    element: <CustomerProfilePage />,
  },
  {
    path: "/strategy-report",
    element: <StrategyReportPage />,
  },
  {
    path: "/strategy-report-detail",
    element: <StrategyReportDetailPage />,
  },
  {
    path: "/strategy-report-wealth-detail",
    element: <StrategyReportWealthDetailPage />,
  },
  {
    path: "/best-cases",
    element: <BestCasesPage />,
  },
  {
    path: "/ai-chat",
    element: <AIChatPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: '/strategy-history',
    element: <StrategyHistory />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
